import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';

const About = () => {
  return (
    <div className="pt-20 pb-32 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeIn className="text-center mb-16">
        <h1 className="text-4xl md:text-6xl font-black mb-8 text-white drop-shadow-[0_2px_20px_rgba(255,255,255,0.2)]">Built by people who make courses</h1>
        <div className="glass-card p-8 md:p-12 text-left border-2 border-brand-border/60">
          <p className="text-lg md:text-xl text-white/80 leading-relaxed mb-6 drop-shadow-[0_2px_8px_rgba(0,0,0,0.3)]">
            VidRevive was born from frustration. After spending hundreds of hours manually converting video content into structured courses, we built the tool we wished existed.
          </p>
          <p className="text-lg md:text-xl text-white/80 leading-relaxed drop-shadow-[0_2px_8px_rgba(0,0,0,0.3)]">
            We're a small team obsessed with making high-quality course creation accessible to every creator and organization.
          </p>
        </div>
      </FadeIn>

      <FadeIn className="text-center">
        <h3 className="text-2xl font-bold mb-8 text-white">Join our team</h3>
        <p className="text-white/70 mb-6">We're always looking for talented engineers and designers.</p>
        <button className="btn-secondary">View Open Roles</button>
      </FadeIn>
    </div>
  );
};

export default About;